import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

// interfaces
import { ILookupTableService } from '../../../shared/interfaces/lookup-table';

// models
import { ApplicationSettings } from '../../../shared/models/application-settings';
import { LookupTable } from '../../../shared/models/lookup-table';
import { Lot } from '../../../shared/models/lot';
import { PrebidOnProduct } from '../../../shared/models/prebid-on-product';

// services
import { WebApiService } from '../../../shared/services/web-api.service';

@Injectable()
export class LookupTableService implements ILookupTableService {

  private apiPath: string;
  private buyerId: number;

  constructor(private appSettings: ApplicationSettings, private webApiService: WebApiService) {
    this.apiPath = this.appSettings.adminApi + 'buyerlevel';
  }

  setId(id: number) {
    this.buyerId = id;
  }

  //ILookupTableService

  getLookupTableForProductPropertyForReports(auctionClusterId: number, productPropertyId: number, lot: Lot): Observable<LookupTable> {
    return this.webApiService.save(`${this.apiPath}/${this.buyerId}/lookuptable/productproperty/${productPropertyId}`, lot);
  }

  getLookupTableForProductPropertyForPrebidOnProduct(auctionClusterId: number, productPropertyId: number, prebidOnProduct: PrebidOnProduct): Observable<LookupTable> { //---
      return this.webApiService.save(`${this.apiPath}/${this.buyerId}/lookuptable/productproperty/${productPropertyId}/prebidonproduct`, prebidOnProduct);
  }

  getLookupTablesForReports(auctionClusterId: number, productId: number): Observable<Array<LookupTable>> {
    return this.webApiService.getList(`${this.apiPath}/${this.buyerId}/lookuptable/product/${productId}`);
  }

  getLookupTables(productId:number, auctionClusterId: number, langCode: string): Observable<Array<LookupTable>> {
    return;
  }
}
